import { call, put } from 'redux-saga/effects';
import * as exchangeRateActions from '../actions/exchangeRate';
import * as API from './api';

function* getLatestRate({ payload }) {
  try {
    const { base, target } = payload;

    const data = yield call(API.getLatestExchangeRate, base, target);

    yield put({
      type: exchangeRateActions.GET_LATEST_RATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: exchangeRateActions.GET_LATEST_RATE_ERROR,
      payload: error,
    });
  }
}

function* getHistoricalRates({ payload }) {
  try {
    const { base, target, startDate, endDate } = payload;

    const data = yield call(API.getHistoricalExchangeRates, base, target, startDate, endDate);

    yield put({
      type: exchangeRateActions.GET_HISTORICAL_RATES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: exchangeRateActions.GET_HISTORICAL_RATES_ERROR,
      payload: error,
    });
  }
}

const sagas = [
  [exchangeRateActions.GET_LATEST_RATE, getLatestRate],
  [exchangeRateActions.GET_HISTORICAL_RATES, getHistoricalRates],
];

export default sagas;
